@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 font-medium">
            {{ field.label | localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          @if (!field.browserOpts.inLineWithCaption) {
            <mat-label>{{ field.label | localize }}</mat-label>
          }
          <mat-select [formControl]="field.control" [placeholder]="field.placeholder | localize"
            [multiple]="field.multiple" [required]="field.required">
            @if (!field.multiple) {
              <mat-option [value]="''">
                {{ 'emptyOption' | transloco }}
              </mat-option>
            }
            @if (!field.distinctValues) {
              @for (opt of field.options; track opt) {
                <mat-option [value]="opt.code" [disabled]="opt.disabled || opt._deprecated">
                  {{ opt.value | localize }}
                </mat-option>
              }
            }
            @if (field.distinctValues) {
              @for (opt of field.distinctOptions; track opt) {
                <mat-option [value]="opt.code" [disabled]="opt.disabled || opt._deprecated">
                  {{ opt.value | localize }}
                </mat-option>
              }
            }
          </mat-select>
          @if (field.hint) {
            <mat-hint>{{ field.hint | localize }}</mat-hint>
          }
          @if (!field.readonly) {
            <mat-error>
              @if (field.control.hasError('required')) {
                {{ 'errorRequiredField' | transloco }}
              }
              @if (field.control.hasError('maxselect')) {
                {{ 'errorMaxSelectField' | transloco:{ maxSelect: field.control.errors.maxselect.max } }}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }
} @else {
  {{ displayedValue }}
}

